import React, { Component } from 'react'
import { Row, Col, Modal, Card } from 'react-bootstrap'

class DailyAttendanceModal extends Component {
    render() {
        console.log("filename", this.props.stateData);
        return (
            <Modal {...this.props}
                size="md" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header
                    closeButton
                >
                    <Modal.Title>Day wise Attendance</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">

                    {
                        this.props.stateData.map((item) => {
                            let status = "";
                            let color = "";
                            if (item.attended_status == 1) {
                                status = "Present"
                                color = "green"
                            } else if (item.attended_status == 0) {
                                status = "Absent"
                                color = "tomato"
                            } else {
                                status = "Sick"
                                color = "#ffc107"
                            }

                            return (
                                <Card className='mt-2 p-3 '>
                                    <Row>
                                        <Col className='text-center'>
                                            <h6>{item.attendance_type}</h6></Col>
                                        <Col className='text-center' style={{ color: color }}><h6>{status}</h6></Col>
                                    </Row>
                                </Card>
                            )
                        })
                    }

                </Modal.Body>
            </Modal>
        )
    }
}

export default DailyAttendanceModal
